import { DateInput } from '@components/index';
import { memo } from 'react';
import { BigInputDiv, InputList } from '../styles';
import { PropsInputSingle, FlattenSingle } from './types';
import { onChangeSingle } from './utils';

type LicenseSingleProps = PropsInputSingle &
  FlattenSingle<'licenseStartDate' | 'licenseEndDate'>;
function LicenseSingle(props: LicenseSingleProps) {
  const { index, licenseStartDate, licenseEndDate, setFormV, onlyGroupEdits } =
    props;
  const licenseStartDateName = `equipments.${index}.licenseStartDate` as const;
  const licenseEndDateName = `equipments.${index}.licenseEndDate` as const;

  return (
    <InputList>
      <BigInputDiv>
        <DateInput
          borderColor="#d8dae5"
          value={licenseStartDate}
          handleDateChange={e => {
            let convDate: Date | null = null;
            if (e) convDate = new Date(e);
            onChangeSingle(licenseStartDateName, convDate, setFormV);
          }}
          disabled={onlyGroupEdits}
        />
      </BigInputDiv>
      <BigInputDiv>
        <DateInput
          borderColor="#d8dae5"
          value={licenseEndDate}
          handleDateChange={e => {
            let convDate: Date | null = null;
            if (e) convDate = new Date(e);
            onChangeSingle(licenseEndDateName, convDate, setFormV);
          }}
          disabled={onlyGroupEdits}
        />
      </BigInputDiv>
    </InputList>
  );
}
export default memo(LicenseSingle);
